//Componentes generales
import React, { useState, useEffect } from "react";
import SearchInput from "../../components/searchInput/SearchInput";
import AddItm from "../addItm/AddItm";

// Estilos
import "./GrupoList.css";

//Components
import GrupoItem from "../GrupoItem/GrupoItem";
import FormGroup from "../FormGroup/FormGroup";

import clienteAxios from "../../config/axios";
import { getUsuariosByGroup } from "../../api/group";
import FormNotificacion from "../FormNotificacion/FormNotificacion";
import GrupoInfo from "../GrupoInfo/GrupoInfo";

function GrupoList({
  grupos = [],
  agregarGroup,
  modificarGroup,
  eliminarGroup,
}) {
  const [verFormAddGroup, setVerFormAddGroup] = useState(false);
  const [verInfoGroup, setVerInfoGroup] = useState(false);
  const [groupSelect, setGroupSelect] = useState();
  const [listaUsuarios, setListaUsuarios] = useState([]);
  //state del filtro por busqueda.
  const [filter, setFilter] = useState("");

  const handlerSeleccionarGroup = async (group, typeSelect = "") => {
    try {
      const resp = await getUsuariosByGroup(group._id);
      const users = resp.data.data.map((d) => {
        return { value: d.user._id, label: d.user.fullName };
      });
      /*  console.log(users); */

      setGroupSelect({ group, members: users, typeSelect });
    } catch (err) {
      console.log(err);
    }
  };

  const handlerCancelarForm = () => {
    setVerFormAddGroup(false);
    setVerInfoGroup(false);
    setGroupSelect(undefined);
  };

  const handdlerSearchInput = (data) => {
    setFilter(data);
  };

  useEffect(() => {
    if (groupSelect !== undefined) {
      switch (groupSelect.typeSelect) {
        case "modificacion":
          return setVerFormAddGroup(true);
        case "info":
          return setVerInfoGroup(true);
        default:
          return setVerFormAddGroup(true);
      }
    }
  }, [groupSelect]);

  useEffect(() => {
    return async () => {
      if (!verFormAddGroup && !verInfoGroup) {
        try {
          const resp = await clienteAxios.get(`/user`);
          setListaUsuarios(
            resp.data.data.map((u) => ({ label: u.fullName, value: u._id }))
          );
        } catch (err) {
          setListaUsuarios([]);
        }
      }
    };
  }, [verFormAddGroup, verInfoGroup]);

  return (
    <div>
      <div style={{ marginLeft: "-300px" }}>
        <SearchInput defaultValue={filter} buscar={handdlerSearchInput} />
      </div>
      <div className="container-group-list">
        <div style={{ marginTop: "-75px", marginBottom: "75px" }}>
          {" "}
          <AddItm
            titulo="Nuevo grupo"
            anadiritm={() => setVerFormAddGroup(true)}
          />
        </div>
        <div className="grupo-scroll">
          {grupos !== null &&
            grupos.map((g) => {
              if (
                filter === "" ||
                g.name.toLowerCase().includes(filter.toLowerCase())
              ) {
                return (
                  <GrupoItem
                    key={g._id}
                    data={g}
                    selectMod={() => handlerSeleccionarGroup(g, "modificacion")}
                    selectDelete={() => eliminarGroup(g._id)}
                    selectInfo={() => handlerSeleccionarGroup(g, "info")}
                  />
                );
              }
            })}
        </div>
      </div>
      {verFormAddGroup && (
        <div className="modalUser">
          <FormGroup
            titulo={
              groupSelect === undefined ? "Agregar Grupo" : "Modificar Grupo"
            }
            minimizar={handlerCancelarForm}
            listaUsuarios={listaUsuarios}
            generar={groupSelect === undefined ? agregarGroup : modificarGroup}
            data={groupSelect}
          />
        </div>
      )}
      {verInfoGroup && (
        <div className="modalUser">
          <GrupoInfo data={groupSelect} minimizar={handlerCancelarForm} />
        </div>
      )}
    </div>
  );
}

export default GrupoList;